<script setup lang="ts">
import type { CollapsibleContentProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { CollapsibleContent } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<CollapsibleContentProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <CollapsibleContent
    v-bind="delegatedProps"
    class="overflow-hidden data-[state=closed]:animate-[collapsible-up_0.3s_ease] data-[state=open]:animate-[collapsible-down_0.3s_ease]"
  >
    <div :class="cn('box-border p-0', props.class)">
      <slot />
    </div>
  </CollapsibleContent>
</template>
